import { useRef } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';

export default function NestingMenu({children, open, onOpen, onClose, menuName="Menu"}){
  const anchor = useRef(null);
  return (
    <>
     <Button
        color='secondary'
        ref={anchor}
        onClick={onOpen}
      >
         {menuName}
      </Button>
      <Menu
        anchorEl={anchor.current}
        open={open}
        onClose={onClose}
      >
        {children}
      </Menu>
    </>
  );
}
